module.exports = __webpack_public_path__ + "img/copy_paste_icon.3bc14941.png";